import Icon from '../components/Icon.vue'

Icon.register({
  snowboarding: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M432 96C458.5 96 480 74.5 480 48S458.5 0 432 0 384 21.5 384 48 405.5 96 432 96zM460.8 249.6C466.6 253.9 473.3 256 480 256 489.7 256 499.3 251.6 505.6 243.2 516.2 229.1 513.4 209 499.2 198.4L387.8 114.9C374 104.6 358.7 96.5 342.4 91.1L278.7 69.9 252.6 17.8C244.7 2 225.5-4.4 209.7 3.5 193.9 11.4 187.5 30.6 195.4 46.4L224.5 104.5C230.2 115.9 240.1 124.4 252.2 128.5L268.6 134 227.4 154.6C205.6 165.5 192 187.4 192 211.8V264.9L117.9 289.6C101.1 295.2 92.1 313.3 97.7 330.1 99.4 335.3 102.6 339.5 106.4 343L67.7 328.9C58 325.4 50.3 318.3 45.9 308.9 40.3 296.9 26 291.7 14 297.3S-3.2 317.2 2.4 329.2C12.2 350.2 29.5 366.1 51.3 374L416.1 506.7C425.8 510.2 435.8 512 445.8 512 458.3 512 470.7 509.3 482.3 503.8 494.3 498.2 499.5 483.9 493.9 471.9S474 454.7 462 460.3C452.7 464.7 442.2 465.1 432.5 461.6L341.7 428.5C350.4 424.4 357.3 416.7 359.5 406.6L381.4 304.6C385.3 286.4 378.2 267.4 363.3 256.2L311.3 217.2 377.3 186.7 460.8 249.6zM316.4 301.3L296.7 393.3C295.2 400.4 296.6 407.2 299.5 413.3L130.1 351.7C132.8 351.5 135.5 351.3 138.1 350.4L223.1 322C242.7 315.5 255.9 297.2 255.9 276.5V256L316.4 301.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/snowboarding.js
// module id = g/JL
// module chunks = 144